export enum GMChatType {
  Group = 'group',
  DM = 'dm',
}
